import { resolveHelpTopic, type HelpTopicId } from "@wmf/shared/help";

export interface SlashQuery {
  start: number; end: number; query: string; kind?: "help";
  topic?: HelpTopicId; browseTopics?: boolean; topicQuery?: string;
}

export function slashQuery(text: string, cursor: number): SlashQuery | null {
  const before = text.slice(0, cursor);
  const match = /(?:^|[\s(])\/(help(?:\/[^/\n]{0,95}|\s[^/\n]{0,95})?)$/i.exec(before)
    ?? /(?:^|[\s(])\/([^/\n]{0,100})$/.exec(before);
  if (!match) return null;
  const raw = match[1]!;
  const range = { start: cursor - raw.length - 1, end: cursor };
  if (!/^help(?:\s|\/|$)/i.test(raw)) return raw.includes("/") ? null : { ...range, query: raw.trim() };
  const rest = raw.slice(4);
  if (!rest || rest.startsWith("/")) {
    const [name = "", ...terms] = rest.slice(1).split(/\s+/);
    if (rest.slice(1).includes("/")) return null;
    const topic = resolveHelpTopic(name);
    return topic ? { ...range, kind: "help", topic, query: terms.join(" ").trim() }
      : { ...range, kind: "help", query: "", browseTopics: true, topicQuery: name };
  }
  return { ...range, kind: "help", query: rest.trim() };
}
